module.exports = __webpack_public_path__ + "img/Phone.97c1a5a0.svg";